import { HStack, IconButton } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Icon } from '$/components/common/Icon';
import { ActionBarTooltip } from '$/components/core/Editor/ActionBar/components/ActionBarTooltip';
import { useDesignGuideStore } from '$/pages/DashboardPages/pages/DesignGuide/stores/useDesignGuideStore';

export const HarmonyViewOptionSelector = ({
  isDisabled,
}: {
  isDisabled?: boolean;
}) => {
  const viewMode = useDesignGuideStore.useViewMode();
  const setViewMode = useDesignGuideStore.useSetViewMode();
  const { t } = useTranslation();

  return (
    <HStack gap='1' display={{ base: 'none', mobile: 'flex' }} py='1'>
      <ActionBarTooltip label={t('dashboard.designGuide.viewMode.scene')}>
        <IconButton
          minW='0'
          minH='0'
          p='0'
          aria-label={t('dashboard.designGuide.viewMode.scene')}
          icon={
            <Icon
              fill={viewMode === 'scene' ? 'text' : 'lighterText'}
              height='24px'
              icon='scene_view'
              opacity={viewMode === 'scene' ? 1 : 0.7}
            />
          }
          isDisabled={isDisabled}
          onClick={() => setViewMode('scene')}
          variant='text'
        />
      </ActionBarTooltip>
      <ActionBarTooltip label={t('dashboard.designGuide.viewMode.color')}>
        <IconButton
          minW='0'
          minH='0'
          p='0'
          aria-label={t('dashboard.designGuide.viewMode.color')}
          icon={
            <Icon
              fill={viewMode === 'color' ? 'text' : 'lighterText'}
              height='24px'
              icon='color_view'
              opacity={viewMode === 'color' ? 1 : 0.7}
            />
          }
          isDisabled={isDisabled}
          onClick={() => setViewMode('color')}
          variant='text'
        />
      </ActionBarTooltip>
    </HStack>
  );
};
